export abstract class IProductAvailabilityNotificationConfirmationDialogService {

  abstract productAvailabilityNotificationConfirmationDialogShow(
    callbackCancel: () => void,
    callbackYes?: () => void,
    callbackNo?: () => void,
  ): unknown;

}
